export function convertTextToSlug(text: string) {
  if (!text)
    return ''

  const translitMap: { [key: string]: string } = {
    // Cyrillic (Russian, Bulgarian, etc.)
    а: 'a',
    б: 'b',
    в: 'v',
    г: 'g',
    д: 'd',
    е: 'e',
    ё: 'yo',
    ж: 'zh',
    з: 'z',
    и: 'i',
    й: 'j',
    к: 'k',
    л: 'l',
    м: 'm',
    н: 'n',
    о: 'o',
    п: 'p',
    р: 'r',
    с: 's',
    т: 't',
    у: 'u',
    ф: 'f',
    х: 'kh',
    ц: 'ts',
    ч: 'ch',
    ш: 'sh',
    щ: 'shch',
    ъ: 'y',
    ы: 'y',
    ь: '',
    э: 'e',
    ю: 'yu',
    я: 'ya',

    // Greek
    α: 'a',
    β: 'v',
    γ: 'g',
    δ: 'd',
    ε: 'e',
    ζ: 'z',
    η: 'i',
    θ: 'th',
    ι: 'i',
    κ: 'k',
    λ: 'l',
    μ: 'm',
    ν: 'n',
    ξ: 'x',
    ο: 'o',
    π: 'p',
    ρ: 'r',
    σ: 's',
    ς: 's',
    τ: 't',
    υ: 'y',
    φ: 'f',
    χ: 'ch',
    ψ: 'ps',
    ω: 'o',
    ά: 'a',
    έ: 'e',
    ή: 'i',
    ί: 'i',
    ό: 'o',
    ύ: 'y',
    ώ: 'o',
  }

  let processedText = text.toString().toLowerCase()

  processedText = processedText.replace(/[\p{Script=Cyrillic}\p{Script=Greek}]/gu, char => translitMap[char] ?? char)

  return processedText
    .normalize('NFD') // Split accented characters into their base letters and diacritical marks (e.g., ą -> a)
    .replace(/[\u0300-\u036F]/g, '') // Remove diacritical marks (strips accents, dots, and tails)
    .toLowerCase()
    .replace(/ł/g, 'l') // Additional fix for Polish 'ł', which normalize might not handle 100% correctly
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .trim()
    .replace(/[\s_]+/g, '-') // Replace spaces and underscores with hyphens
    .replace(/-+/g, '-') // Remove duplicate consecutive hyphens
    .replace(/^-+|-+$/g, '') // Trim hyphens from the start and end of the string
}
